import { useSelector } from 'react-redux';
import { getSession } from '../../SessionProvider/redux/selectors';
export function useMetaRobots(directives, deviation) {
    var _session_seo;
    const session = useSelector(getSession);
    const robots = session === null || session === void 0 ? void 0 : (_session_seo = session.seo) === null || _session_seo === void 0 ? void 0 : _session_seo.robots;
    return getRobotsContent(directives, robots, deviation);
}
export function getRobotsContent(directives, robots, deviation) {
    const out = [];
    // Default
    out.push('max-image-preview:large');
    // Robots from backend
    if (robots) {
        out.push(robots);
    }
    // No AI
    if (deviation === null || deviation === void 0 ? void 0 : deviation.isAiUseDisallowed) {
        out.push('noimageai');
    }
    return `${out.join(',')}${directives ? `, ${directives}` : ''}`;
}

//# sourceMappingURL=useMetaRobots.js.map